export const DASHBOARD_CAP = "Dashboard";
export const TRANSACTIONS_CAP = "Transactions";
export const BANK_TRANSACTIONS_CAP = "Bank Transactions";
export const BANK_ACCOUNTS_CAP = "Bank Accounts";
export const USERS_CAP = "Users";
export const SUB_ADMINS_CAP = "Sub-admins";
export const MASTERS_CAP = "Masters";
export const COUNTRY_CAP = "Country";
export const COUNTRIES_CAP = "Countries";
export const STATE_CAP = "State";
export const STATES_CAP = "States";
export const CITY_CAP = "City";
export const CITIES_CAP = "Cities";
export const REFUNDS_CAP = "Refunds";
export const NOTIFICATIONS_CAP = "Notifications";
export const ACCESS_LOG_CAP = "Access Log";
export const REPORT_ABUSES_CAP = "Report Abuses";
export const SETTINGS_CAP = "Settings";
export const BANK_CAP = "Bank";
export const COMMISSIONS_CAP = "Commissions";
export const TRANSACTIONS_REPORT_CAP = "Transactions Report";
export const CLEARING_ACCOUNT_REPORT_CAP = "Clearing Account Report";

// date format
export const DDD_DD_MMM_YYYY = "ddd DD MMM YYYY";
export const HH_MM_SS_A = "hh:mm:ss a";
export const DDD_DD_MMM_YYYY_HH_MM_SS_A = "ddd DD MMM YYYY hh:mm:ss a";
export const MM_DD_YY = "MM/DD/YY";
export const TIME_ZONE = "America/New_York";
export const YYYY_MM_DD = "YYYY/MM/DD";
export const DD_MM_YYYY_HH_MM_SS = "DD-MM-YYYY hh:mm:ss";
export const YYYY_MM_DD_HH_MM_SS = "YYYY-MM-DD HH:mm:ss";

export const TRANSACTION_ID_CAPITAL = "TRANSACTION ID";
export const SENDER_NAME_CAPITAL = "SENDER NAME";
export const RECEIVER_NAME_CAPITAL = "RECEIVER NAME";
export const AMOUNTS_CAPITAL = "AMOUNTS";
export const COMMISSION_CAPITAL = "COMMISSION";
export const DATE_CAPITAL = "DATE";
export const CONFIRMATION_ID_CAPITAL = "CONFIRMATION ID";
export const CONFIRMATION_DATE_CAPITAL = "CONFIRMATION DATE";
export const SC_TRANSACTION_ID_CAPITAL = "SC-TRANSACTION ID";
export const SC_TRANSACTION_TYPE_CAPITAL = "SC-TRANSACTION TYPE";
export const DEPOSITE_TYPE_CAPITAL = "DEPOSIT TYPE";
export const STATUS_CAPITAL = "STATUS";
export const IP_CAPITAL = "IP";
export const EXPECTED_DELIVERY_DATE_CAPITAL = "EXPECTED DELIVERY DATE";
export const EXPECTED_DELIVERY_DATE_CAP = "Expected Delivery Date";
export const FUNDS_CAP = "Funds";
export const TOTAL_PAYXTREME_FUNDS_CAP = "Total PayXtreme Funds";
export const TOTAL_PAYXTREME_MADE_FUNDS_CAP = "Total Made Funds";
export const TOTAL_REQUESTED__FUNDS_CAP = "Total Requested Funds";
export const TOTAL_PENDING_REQUESTED_FUNDS_CAP = "Total Pending Request";
export const TOTAL_BANK_TRANSACTIONS_CAP = "Total Bank Transactions";
export const TOTAL_COMMISSION = "Total Commission";
export const TOTAL_TRANSACTION_FUNDS_WITH_SC_CAP =
  "Total Transaction Funds With SC";
export const STATISTICS_CAP = "Statistics";
export const TOTAL_TRANSACTIONS_CAP = "Total Transactions";
export const TOTAL_TRANSACTION_WITH_SC_CAP = "Total Transaction with SC";
export const TOTAL_MAKE_A_PAYMENT_CAP = "Total Make A Payment";
export const TOTAL_REQUEST_A_PAYMENT_CAP = "Total Request A Payment";
export const TOTAL_PENDING_REQUESTS_CAP = "Total Pending Requests";
export const TOTAL_WITHDRAW_REQUESTS_CAP = "Total Withdraw Requests";
export const TOTAL_REFUND_REQUESTS_CAP = "Total Refund Requests";
export const TOTAL_PAYMENT_REJECTED_REQUESTS_CAP = "Total Rejected Requests";
export const TOTAL_PENDING_BANK_CONFIRMATION_CAP =
  "Total Pending Bank Confirmations";
export const TOTAL_USERS_CAP = "Total Users";
export const TOTAL_BUSINESS_USERS_CAP = "Total Business Users";
export const TOTAL_ACTIVE_USERS_CAP = " Total Active Users";
export const TOTAL_INACTIVE_USERS_CAP = "Total Inactive Users";
export const BANK_VERIFICATION_PENDING_CAP = "Bank verification pending";
export const NETWORK_ERROR = "Network Error!, Please try again after some time";
